import api from "@/plugins/api/EntryPoint";
export default {
  checkDebt(ls, callBackFn) {
    return api.post(
      `easypay-nocommission/debt-check`,
      { account_number: ls },
      callBackFn
    );
  },
  makePayment(paymentData, callBackFn) {
    console.log(
      "CHLENIX NO COMISSION makePayment: ",
      JSON.stringify(paymentData)
    );
    return api.post(
      `easypay-nocommission/pay`,
      {
        account_number: paymentData.ls,
        amount: paymentData.amount,
        card_number: paymentData.cardNumber,
        card_expiry: paymentData.cardExpiry,
        card_cvv: paymentData.cardCvv,
      },
      callBackFn
    );
  },
  getCards(callBackFn) {
    return api.get(`easypay-nocommission/get-cards`, callBackFn);
  },
  payWithSavedCard(paymentData, callBackFn) {
    console.log(
      "CHLENIX NO COMISSION payWithSavedCard: ",
      JSON.stringify(paymentData)
    );
    return api.post(
      `easypay-nocommission/pay-with-save-card`,
      {
        account_number: paymentData.ls,
        amount: paymentData.amount,
        card_id: paymentData.cardId,
      },
      callBackFn
    );
  },
};
